module.exports = __webpack_public_path__ + "1f31ebc85c4f4458d2d0d1084abde21d.svg";